export const GoogleMapsAPIKey = "AIzaSyDkSOLEbBmczlfAuZvv4N1-TMeM2JFJTpU";
export const GoogleTagsKey = "G-QPVDJZ86R8";
export const GoogleCaptchaKey = "6Lfz-T0rAAAAACOB4IFWYEY-a_hkmd-8Ut3wcxVu";

export const GoogleOauthID = '326075138809-g5kvqf1458ngrfj83v3fmhsvfgabhmun.apps.googleusercontent.com';